import { render, staticRenderFns } from "./FertilizerModal.vue?vue&type=template&id=32736df4&scoped=true&"
import script from "./FertilizerModal.vue?vue&type=script&lang=js&"
export * from "./FertilizerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32736df4",
  null
  
)

export default component.exports